<template>
  <div>
    <div id="headerDetail" classs="is-flex-column">
      <router-link
        to="/staff-list"
        class="is-justify-end is-align-center is-flex-medium is-flex-row box-back-page"
      >
        <p class="text-back-page backpage-color">
          <i class="fas fa-arrow-left"></i>
          {{ $t("message.btnBackToStaffList") }}
        </p>
      </router-link>

      <div class="columns is-vcentered width-max m-h-auto">
        <div class="column is-1 has-text-centered">
          <div class="is-align-center is-justify-center is-flex is-flex-column">
            <figure class="image imgStaff">
              <img
                class="is-rounded"
                v-if="staffDetail.profilePic"
                :src="imgUrl + staffDetail.profilePic"
                alt="Profile Picture"
                @error="
                  $event.target.src =
                    'https://bulma.io/images/placeholders/128x128.png'
                "
              />
              <img
                class="is-rounded"
                v-else
                src="https://bulma.io/images/placeholders/128x128.png"
                alt="Placeholder image"
              />
            </figure>
          </div>
        </div>

        <div class="column">
          <p
            class="is-size-4 has-text-centered-mobile has-text-weight-bold pd-column-small"
          >
            {{ $t("staffList.staffDetailDashboard") }}
          </p>
          <div class="columns m-h-auto is-marginless">
            <div class="column is-3 has-text-centered-mobile pd-column-small">
              <p class="is-size-6 has-text-weight-bold">
                {{ $t("staffList.staffDetailName") }}:
                <span class="confirm-padding-left th fw-100">{{
                  staffDetail.name
                }}</span>
              </p>
            </div>
            <div class="column has-text-centered-mobile pd-column-small">
              <p class="is-size-6 has-text-weight-bold">
                {{ $t("staffList.staffDetailLastname") }}:
                <span class="confirm-padding-left th fw-100">{{
                  staffDetail.surname
                }}</span>
              </p>
            </div>
          </div>
          <div class="columns m-h-auto is-marginless">
            <div class="column is-3 has-text-centered-mobile pd-column-small">
              <p class="is-size-6 has-text-weight-bold">
                {{ $t("staffList.staffDetailPosition") }}:
                <span class="confirm-padding-left th fw-100">{{
                  staffDetail.position
                }}</span>
              </p>
            </div>
            <div class="column has-text-centered-mobile pd-column-small">
              <p class="is-size-6 has-text-weight-bold">
                {{ $t("staffList.staffDetailTelephone") }}:
                <span class="confirm-padding-left th fw-100">{{
                  staffDetail.mobilePhone
                }}</span>
              </p>
            </div>
          </div>
          <div class="columns m-h-auto is-marginless">
            <div class="column has-text-centered-mobile pd-column-small">
              <p class="is-size-6 has-text-weight-bold">
                {{ $t("staffList.staffDetailEmail") }}:
                <span class="confirm-padding-left th fw-100">{{
                  staffDetail.email
                }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>
<script>
export default {
  computed: {
    staffDetail() {
      return this.$store.state.staffDetail;
    },
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMAGE_URL,
    };
  },
};
</script>
<style scoped>
#headerDetail {
  min-height: 191px !important;
}
</style>
